// Hides admin-only chrome (Garden tab, feedback widget, admin menu entries)
// so reels can be screen-recorded on the real admin account. Toggled from the
// Account page; reload so every gate re-evaluates.
const KEY = "stoop.recordingMode";

export function recordingModeActive(): boolean {
  try {
    return window.localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function setRecordingMode(on: boolean): void {
  try {
    if (on) window.localStorage.setItem(KEY, "1");
    else window.localStorage.removeItem(KEY);
  } catch { /* private mode */ }
  window.location.reload();
}
